
import { Injectable, Input } from '@angular/core';
import { BehaviorSubject, filter, map, Observable, tap, finalize } from 'rxjs';

import { PortalGroupApiService } from 'src/app/shared/api/services/portal-group-api.service';
import { from, of } from 'rxjs';
import { concatMap, delay} from 'rxjs/operators';
import { PortalGroup } from 'src/app/data/model/portal-group';
import * as L from 'leaflet';
import { VehicleApiService } from 'src/app/shared/api/services/vehicle-api.service';
import { Vehicle } from 'src/app/data/model/vehicle';
import * as A from 'leaflet-marker-rotation';
import { GpsTrackingApiService } from 'src/app/shared/api/services/gps-track-api.service';
import { VehiclesViewApiService } from 'src/app/shared/api/services/vehicles-view-api.service';
import { GpsTrackPoint } from 'src/app/data/model/gps_tracking';
import { BaseEntityListService } from 'src/app/shared/base/base-entity-list.service';
import { MatDialog } from '@angular/material/dialog';
import { BaseListService } from 'src/app/shared/base/base-list.service';
import { BaseEntityService } from 'src/app/shared/base/base-entity.service';
import { DeviceApiService } from 'src/app/shared/api/services/device-api.service';
import { Device } from 'src/app/data/model/device';
import { MapDialogComponent } from '../components/map.component';
//import "leaflet.markercluster/dist/MarkerCluster.Default.css"; 
//import 'leaflet.markercluster';
import { VehiclesView } from 'src/app/data/model/vehicles-view';
import { GpsTrackPointView } from 'src/app/data/model/gps-tracking-view';
import { DeviceEventViewApiService } from 'src/app/shared/api/services/events-api.service';
import { DeviceEventView } from 'src/app/data/model/device-event-view';
import { NoGpsPointsDialogComponent } from '../components/no-gps-points.component';
import {Icon, DomEvent, Path, Map, LayerGroup, MapOptions, tileLayer, LatLng, latLng, Marker , MarkerClusterGroup, MarkerClusterGroupOptions, divIcon, ZoomAnimEvent, FullscreenOptions, Control, DomUtil, control, marker, Layer, GridLayerOptions, latLngBounds, LatLngBounds, GridLayer, FeatureGroup } from 'leaflet';
import * as moment from 'moment';



@Injectable()
export class GpsMarkerService extends BaseEntityService<
GpsTrackPointView ,
GpsTrackingApiService
> {
  public map!:Map
 
  constructor(
    apiService: GpsTrackingApiService,
    private portalGroupService: PortalGroupApiService,
    private vehicleService: VehicleApiService,
    private deviceService: DeviceApiService,
    private dialog:MatDialog
  ) {
    super(apiService);
  }

  private groupsSubject = new BehaviorSubject<PortalGroup[] | null>(null);
  private vehiclesSubject = new BehaviorSubject<Vehicle[] | null>(null);
  private deviceSubject = new BehaviorSubject<Device[] | null>(null);
  private gpspointSubject = new BehaviorSubject<GpsTrackPointView[] | null>(null);
  public loadingSubject = new BehaviorSubject<boolean>(false);

  get vehicles$(): Observable<Vehicle[] | null> {
    return this.vehiclesSubject.asObservable();
  }
  get groups$() {
    return this.groupsSubject.asObservable();
  }
  get devices$(): Observable<Device[] | null>{
    return this.deviceSubject.asObservable();
  }
  get observable_loading$() {
    return this.loadingSubject.asObservable();
  }
  private openNoGpsPointsDialog(): void {
    this.dialog.open(NoGpsPointsDialogComponent, {
      width: '300px',
      data: { message: 'Non ci sono dati disponibili.' }//il mezzo selezionato non riporta nessun punto GPS
    });
  }

  loadGroup() {
    this.portalGroupService
      .getAll()
      .pipe(tap((res:any) => this.groupsSubject.next(res.results)))
      .subscribe();
  }


  loadPlates() { 
    this.vehicleService
      .getAll()
      .pipe(tap((res:any) => this.vehiclesSubject.next(res.results)))
      .subscribe((res:any)=>res.results);
  }

  loadDevices() {
    this.deviceService
      .getAll()
      .pipe(tap((res:any) => this.deviceSubject.next(res.results)))
  }

  setIcon(type:String){
    if (type === 'start') {
      return Icon.extend({
        options:
          {
            iconSize: [31, 31], // size of the icon
            iconAnchor: [10, 24], // 8, 24 point of the icon which will correspond to marker's location
            popupAnchor: [0, -51],  
            iconUrl: '../../../../assets/images/home.png'
          }
        })
    } else if (type === 'stop') {
      return Icon.extend({
        options:
          {
            iconSize: [31, 31], // size of the icon
            iconAnchor: [10, 24], // 8, 24 point of the icon which will correspond to marker's location
            popupAnchor: [0, -51],  
            iconUrl: '../../../../assets/images/finish_vehicle.png'
          }
        })
    } else {
      return Icon.extend({
        options:
          {
            iconSize: [24, 24], // size of the icon
            iconAnchor: [12, 12], // 12, 22 point of the icon which will correspond to marker's location
            popupAnchor: [0, -51],    
            iconUrl: '../../../../assets/images/nord.png'
          }
        })
    }
  }

  setRandomIcon(type:number){
    if (type === 1) {
      return L.Icon.extend({
        options:
          {
            iconSize: [this.map.getZoom()+20, this.map.getZoom()+20], // size of the icon
            iconAnchor: [this.map.getZoom() / 2, this.map.getZoom()],//[10, 24], // 8, 24 point of the icon which will correspond to marker's location
            popupAnchor: [0, -this.map.getZoom()], //[0, -51],  
            iconUrl: '../../../../assets/images/last1.png'
          }
        })
    } else if (type === 2) {
      return L.Icon.extend({
        options:
          {
            iconSize: [this.map.getZoom()+20, this.map.getZoom()+20], // size of the icon
            iconAnchor: [this.map.getZoom() / 2, this.map.getZoom()],//[10, 24], // 8, 24 point of the icon which will correspond to marker's location
            popupAnchor: [0, -this.map.getZoom()], //[0, -51],  
            iconUrl: '../../../../assets/images/last2.png'
          }
        })
    } else if (type === 3) {
      return L.Icon.extend({
        options:
          {
            iconSize: [this.map.getZoom()+20, this.map.getZoom()+20], // size of the icon
            iconAnchor: [this.map.getZoom() / 2, this.map.getZoom()],//[10, 24], // 8, 24 point of the icon which will correspond to marker's location
            popupAnchor: [0, -this.map.getZoom()], //[0, -51],  
            iconUrl: '../../../../assets/images/last3.png'
          }
        })
    } else if (type === 4) {
      return L.Icon.extend({
        options:
          {
            iconSize: [this.map.getZoom()+20, this.map.getZoom()+20], // size of the icon
            iconAnchor: [this.map.getZoom() / 2, this.map.getZoom()],//[10, 24], // 8, 24 point of the icon which will correspond to marker's location
            popupAnchor: [0, -this.map.getZoom()], //[0, -51],  
            iconUrl: '../../../../assets/images/last4.png'
          }
        })
    }else if (type === 5) {
      return L.Icon.extend({
        options:
          {
            iconSize: [this.map.getZoom()+20, this.map.getZoom()+20], // size of the icon
            iconAnchor: [this.map.getZoom() / 2, this.map.getZoom()],//[10, 24], // 8, 24 point of the icon which will correspond to marker's location
            popupAnchor: [0, -this.map.getZoom()], //[0, -51],  
            iconUrl: '../../../../assets/images/last5.png'
          }
        })
    }else if (type === 6) {
      return L.Icon.extend({
        options:
          {
            iconSize: [this.map.getZoom()+20, this.map.getZoom()+20], // size of the icon
            iconAnchor: [this.map.getZoom() / 2, this.map.getZoom()],//[10, 24], // 8, 24 point of the icon which will correspond to marker's location
            popupAnchor: [0, -this.map.getZoom()], //[0, -51],  
            iconUrl: '../../../../assets/images/last6.png'
          }
        })
    }else if (type === 7) {
      return L.Icon.extend({
        options:
          {
            iconSize: [this.map.getZoom()+20, this.map.getZoom()+20], // size of the icon
            iconAnchor: [this.map.getZoom() / 2, this.map.getZoom()],//[10, 24], // 8, 24 point of the icon which will correspond to marker's location
            popupAnchor: [0, -this.map.getZoom()], //[0, -51],  
            iconUrl: '../../../../assets/images/last7.png'
          }
        })
    }else if (type === 8) {
      return L.Icon.extend({
        options:
          {
            iconSize: [this.map.getZoom()+20, this.map.getZoom()+20], // size of the icon
            iconAnchor: [this.map.getZoom() / 2, this.map.getZoom()],//[10, 24], // 8, 24 point of the icon which will correspond to marker's location
            popupAnchor: [0, -this.map.getZoom()], //[0, -51],  
            iconUrl: '../../../../assets/images/last8.png'
          }
        })
    }else if (type === 9) {
      return L.Icon.extend({
        options:
          {
            iconSize: [this.map.getZoom()+20, this.map.getZoom()+20], // size of the icon
            iconAnchor: [this.map.getZoom() / 2, this.map.getZoom()],//[10, 24], // 8, 24 point of the icon which will correspond to marker's location
            popupAnchor: [0, -this.map.getZoom()], //[0, -51],  
            iconUrl: '../../../../assets/images/last9.png'
          }
        })
    }else if (type === 10) {
      return L.Icon.extend({
        options:
          {
            iconSize: [this.map.getZoom()+20, this.map.getZoom()+20], // size of the icon
            iconAnchor: [this.map.getZoom() / 2, this.map.getZoom()],//[10, 24], // 8, 24 point of the icon which will correspond to marker's location
            popupAnchor: [0, -this.map.getZoom()], //[0, -51],  
            iconUrl: '../../../../assets/images/last10.png'
          }
        })
    }else if (type === 11) {
      return L.Icon.extend({
        options:
          {
            iconSize: [this.map.getZoom()+20, this.map.getZoom()+20], // size of the icon
            iconAnchor: [this.map.getZoom() / 2, this.map.getZoom()],//[10, 24], // 8, 24 point of the icon which will correspond to marker's location
            popupAnchor: [0, -this.map.getZoom()], //[0, -51],  
            iconUrl: '../../../../assets/images/last11.png'
          }
        })
    }else if (type === 12) {
      return L.Icon.extend({
        options:
          {
            iconSize: [this.map.getZoom()+20, this.map.getZoom()+20], // size of the icon
            iconAnchor: [this.map.getZoom() / 2, this.map.getZoom()],//[10, 24], // 8, 24 point of the icon which will correspond to marker's location
            popupAnchor: [0, -this.map.getZoom()], //[0, -51],  
            iconUrl: '../../../../assets/images/last12.png'
          }
        })
    }else {
      return L.Icon.extend({
        options:
          {
            iconSize: [this.map.getZoom()+20, this.map.getZoom()+20], // size of the icon
            iconAnchor: [this.map.getZoom() / 2, this.map.getZoom()],//[10, 24], // 8, 24 point of the icon which will correspond to marker's location
            popupAnchor: [0, -this.map.getZoom()], //[0, -51],  
            iconUrl: '../../../../assets/images/last12.png'
          }
        })
    }
  }

  setPopUpData(c:any, timestamp:string, speed:number):string{
    return`<div>
    <table style=\"width:100%; border-radius: 0px; font-size:15px;\">
      <tr style=\"background-color:#3f51b5; color:white\">
        <td>
          <b/>Descrizione: ${c.licenseplate.brand ? c.licenseplate.brand : ''} ${c.licenseplate.model ? c.licenseplate.model : ''}
        </td>
      </tr>
      <tr>
        <td>
          <b/>Gruppo: ${c.name}
        </td>
      </tr>
      <tr style=\"background-color:#3f51b5; color:white\">
        <td>
          <b/>Targa: ${c.licenseplate.licenseplate}
        </td>
      </tr>
      <tr>
        <td>
          <b/>------------
        </td>
      </tr>
      <tr>
        <td>
          <b/>Data/Ora: ${timestamp}
        </td>
      </tr>
      <tr style=\"background-color:#3f51b5; color:white\">
        <td>
          <b/>Velocità: ${Math.round(speed)} Km/h
        </td>
      </tr>
    </table>
    </div>`;
  }

  filterVehiclePoints(layer: L.FeatureGroup, vehicle:string, start_date:Date, end_date:Date){
    layer.clearLayers();
    this.loadingSubject.next(true);
    //this.trackDate$.next(null);
    var created_at:string=start_date+","+end_date
    //this.filterDate$.next(created_at);
    this.apiService
      .getFilteredGeoGPS(vehicle, created_at)
      .pipe(tap((res:any) => this.gpspointSubject.next(res.results)))
      .pipe(finalize(() => this.loadingSubject.next(false)))
      .subscribe((res:any) => {
        if(res.results.length ===0){
          this.openNoGpsPointsDialog();
        }
        else {
          for (const c of res.results) {
            //this.trackDate$.next(new Date(c.gps_timestamp));
            var color:any;
            var r = Math.floor(Math.random() * (255+Math.random()));
            var g = Math.floor(Math.random() * (255+Math.random()));
            var b = Math.floor(Math.random() * (255+Math.random()));
            color= "rgb("+r+" ,"+g+","+ b+")"; 
            L.geoJSON(c.coords, {
              pointToLayer: (feature, latlng) => {
                let icon;
                let rotation = 0;
    
                
                icon = this.setIcon(feature.properties?.type);
                rotation = feature.properties?.angle || 0;

                var marker=new A.RotatedMarker(latlng, {
                  icon: new icon,
                  rotationAngle: rotation
                });
                if (feature.properties?.type==='start' || feature.properties?.type==='stop') {
                  marker.setZIndexOffset(1000);
                }

                marker.bindPopup('Caricamento in corso....', { closeButton: false });

                // 🔹 API call when popup opens
                marker.on('popupopen', () => {

                  // Optional: prevent multiple calls
                  if ((marker as any)._apiLoaded) return;
                  (marker as any)._apiLoaded = true;

                  

                  this.apiService
                    //.getFiltered(id, {last_lap: id})
                    .getWithFilter({id: feature.properties?.id})
                    .pipe(tap((res:any) => this.gpspointSubject.next(res.results)))
                    //.pipe(finalize(() => this.loadingSubject.next(false)))
                    .subscribe((res:any) => {
                      //const data = res.results.filter((x:GpsTrackPointView)=>x.data_collector_id== id);
                      for (const c of res.results) {
                        const timestamp = new Date(c.gps_timestamp).toLocaleString();
                        const speed = c.ground_speed * 3.6
                        const data:string=this.setPopUpData(c, timestamp, speed);
                        marker.setPopupContent(data);
                      }
                  });
                });
                return marker
              },
    
              onEachFeature: function (feature,layer:L.FeatureGroup) {
                if (feature.geometry.type !== 'Point' && feature.properties?.style){
                  const lineStyle = feature.properties.style
                  const style={
                    dashArray: lineStyle.dashArray,
                    color:lineStyle.color ||color,
                    weight:lineStyle.weight,
                    opacity:2
                  }
                  layer.setStyle(style)
                }
              }
            }).addTo(layer);
          }
        }
      });
  }

  vehiclePoints( layer:L.FeatureGroup, id:number){
    this.loadingSubject.next(true);
    layer.clearLayers();
    this.apiService
      .getGeoJsonFiltered(id)
      .pipe(tap((res:any) => this.gpspointSubject.next(res.results)))
      .pipe(finalize(() => this.loadingSubject.next(false)))
      //.pipe(finalize(() => this.loadingSubject.next(false)))
      .subscribe((res:any) => {
        if(res.results.length ===0){
          this.openNoGpsPointsDialog();
        }
        else {
          for (const c of res.results) {
            //this.trackDate$.next(new Date(c.gps_timestamp));
            var color:any;
            var r = Math.floor(Math.random() * (255+Math.random()));
            var g = Math.floor(Math.random() * (255+Math.random()));
            var b = Math.floor(Math.random() * (255+Math.random()));
            color= "rgb("+r+" ,"+g+","+ b+")"; 
            L.geoJSON(c.coords, {
              pointToLayer: (feature, latlng) => {
                let icon;
                let rotation = 0;
    
                
                icon = this.setIcon(feature.properties?.type);
                rotation = feature.properties?.angle || 0;

                var marker=new A.RotatedMarker(latlng, {
                  icon: new icon,
                  rotationAngle: rotation
                });

                if (feature.properties?.type==='start' || feature.properties?.type==='stop') {
                  marker.setZIndexOffset(1000);
                }


                marker.bindPopup('Caricamento in corso....', { closeButton: false });

                // 🔹 API call when popup opens
                marker.on('popupopen', () => {

                  // Optional: prevent multiple calls
                  if ((marker as any)._apiLoaded) return;
                  (marker as any)._apiLoaded = true;

                  

                  this.apiService
                    //.getFiltered(id, {last_lap: id})
                    .getWithFilter({id: feature.properties?.id})
                    .pipe(tap((res:any) => this.gpspointSubject.next(res.results)))
                    //.pipe(finalize(() => this.loadingSubject.next(false)))
                    .subscribe((res:any) => {
                      //const data = res.results.filter((x:GpsTrackPointView)=>x.data_collector_id== id);
                      for (const c of res.results) {
                        const timestamp = new Date(c.gps_timestamp).toLocaleString();
                        const speed = c.ground_speed * 3.6
                        const data:string=this.setPopUpData(c, timestamp, speed);
                        marker.setPopupContent(data);
                      }
                  });
                });
                return marker
              },
    
              onEachFeature: function (feature,layer:L.FeatureGroup) {
                if (feature.geometry.type !== 'Point' && feature.properties?.style){
                  const lineStyle = feature.properties.style
                  const style={
                    dashArray: lineStyle.dashArray,
                    color:lineStyle.color ||color,
                    weight:lineStyle.weight,
                    opacity:2
                  }
                  layer.setStyle(style)
                }
              }
            }).addTo(layer);
          }
        }
      });
  }
  

 

  setMap(map:Map): void {
    this.map=map;
  }

  

  allVehiclePoints(layer: L.FeatureGroup, selected: any[]) {
    let no_data = 0;
    layer.clearLayers();

    from(selected).pipe(
      concatMap((item, index) =>
        this.apiService
          .getGeoJsonFiltered(item.data_collector)
          .pipe(
            tap((res:any) => this.gpspointSubject.next(res.results)),
            delay(500) // ⏱ timeout between API calls
          )
      )
    )
    .subscribe((res: any) => {

      if (res.results.length === 0) {
        no_data++;
      } else {
        for (const c of res.results) {
          const r = Math.floor(Math.random() * 255);
          const g = Math.floor(Math.random() * 255);
          const b = Math.floor(Math.random() * 255);
          const color = `rgb(${r},${g},${b})`;

          L.geoJSON(c.coords, {
            pointToLayer: (feature, latlng) => {
              const icon = this.setIcon(feature.properties?.type);
              const rotation = feature.properties?.angle || 0;

              var marker = new A.RotatedMarker(latlng, {
                icon: new icon,
                rotationAngle: rotation
              });

              if (feature.properties?.type==='start' || feature.properties?.type==='stop') {
                marker.setZIndexOffset(1000);
              }


              marker.bindPopup('Caricamento in corso....', { closeButton: false });

              marker.on('popupopen', () => {
                if ((marker as any)._apiLoaded) return;
                (marker as any)._apiLoaded = true;

                this.apiService
                  .getWithFilter({ id: feature.properties?.id })
                  .subscribe((res: any) => {
                    for (const c of res.results) {
                      const timestamp = new Date(c.gps_timestamp).toLocaleString();
                      const speed = c.ground_speed * 3.6;
                      marker.setPopupContent(
                        this.setPopUpData(c, timestamp, speed)
                      );
                    }
                  });
              });

              return marker;
            }
          }).addTo(layer);
        }
      }

      if (no_data === selected.length) {
        this.openNoGpsPointsDialog();
      }
    });
  }

  setMapData(data: Vehicle) {
    return{
      coords: data.coords,
      pop_up_data:`<div>
      <table style=\"width:100%; border-radius: 0px; font-size:15px;\">
        <tr style=\"background-color:#3f51b5; color:white\">
          <td>
            <b/>ID Veicolo: ${data.licenseplate}
          </td>
        </tr>
        <tr>
          <td>
            <b/> Descrizione: ${data.brand ? data.brand : ''} ${data.model ? data.model : ''}
          </td>
        </tr>
        <tr style=\"background-color:#3f51b5; color:white\">
          <td>
            <b/>Data Punto: ${moment(data.last_gps_update).format('DD/MM/yyyy, HH:mm:ss')}
          </td>
        </tr>
        <tr>
          <td>
            <b/>Gruppo: ${data.data_collector_item?.group_item?.name}
          </td>
        </tr>
      </table>
      </div>`
    } 
  }
  
  loadVehiclesLastPoint(markers: L.FeatureGroup, vehicle:number) {
    markers.clearLayers();
    this.vehicleService
      .get(vehicle)
      .subscribe((res:any) => {
        if(!res){
          this.openNoGpsPointsDialog();
        }
        else {
          let point
          const coords = res.coords.split(" ");
          const mark1= coords[1].split("(");
          const mark2= coords[2].split(")");
          if(mark1[1] < mark2[0]){
            point = new LatLng(mark2[0], mark1[1]);
          }else{
            point = new LatLng(mark1[1], mark2[0]);
          }
          
          const data=this.setMapData(res);
          //var data:string="<div><table style=\"width:100%; border-radius: 0px; font-size:15px;\"><tr style=\"background-color:#3f51b5; color:white\"><td><b/>Targa: "+res.licenseplate+"</td></tr></table></div>";
          
          const myicon=this.setRandomIcon(Math.floor(Math.random() * 12) + 1)//this.setIcon('standard')
          var marker = L.marker(point,{icon: new myicon}).bindPopup(data.pop_up_data, {closeButton: false});
          
          marker.addTo(markers);
        }
      });
  }

  loadLastPoints(markers: L.FeatureGroup) {
    this.loadingSubject.next(true);
    markers.clearLayers();
    this.vehicleService
      .getWithFilter({visible_on_map:true, limit:0, offset:0})
      .pipe(finalize(() => this.loadingSubject.next(false)))
      .subscribe((res:any) => {
        if(res.results.length === 0){
          this.openNoGpsPointsDialog();
        }
        else {
          let point:LatLng
          //const data = res.results.filter((x:GpsTrackPointView)=>x.data_collector_id== id);
          for (const c of res.results) {
            const coords = c.coords.split(" ");
            const mark1= coords[1].split("(");
            const mark2= coords[2].split(")");
            if(mark1[1] < mark2[0]){
              point = new LatLng(mark2[0], mark1[1]);
            }else{
              point = new LatLng(mark1[1], mark2[0]);
            }
            
            const data=this.setMapData(c);

            //var data:string="<div><table style=\"width:100%; border-radius: 0px; font-size:15px;\"><tr style=\"background-color:#3f51b5; color:white\"><td><b/>Targa: "+c.licenseplate+"</td></tr></table></div>";
            
            const myicon=this.setRandomIcon(Math.floor(Math.random() * 12) + 1)//this.setIcon('standard')
            var marker = L.marker(point,{icon: new myicon}).bindPopup(data.pop_up_data, {closeButton: false});
            
            marker.addTo(markers);
          }
        }
      });
  }
}
